export const language = {
	title: 'Core Competencies',
};
